var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "table-responsive table-content",
      class: { "table-columns-fixed": _vm.fixedColumns }
    },
    [_c("table", { staticClass: "table-bordered" }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }